import { IconStatus } from '../../../../shared/components/status/IconStatus';
import { updateAnnotation } from '../../thunks/update-annotation-task.thunks';
import { useDispatch } from 'react-redux';
import {
  Button,
  ChevronDownIcon,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
} from '@cdl/heartbeat-react';
import { OptionStatus } from './OptionStatus';
import { AnnotationTask } from '../../../ecg/types/annotation-tasks.type';

type Props = {
  status: string;
  annotationTask: AnnotationTask;
};

export const StatusColumn: React.FC<Props> = ({ status, annotationTask }) => {
  const dispatch = useDispatch();

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        leftIcon={<IconStatus statusOption={status} />}
        variant='secondary'
        width='full'
        size='xs'
      >
        <Text
          textTransform='capitalize'
          noOfLines={0}
          textStyle='category-subtitle'
        >
          {status}
        </Text>
      </MenuButton>
      <MenuList>
        <MenuOptionGroup
          type='radio'
          value={status}
          onChange={(value) => {
            if (!Array.isArray(value)) {
              dispatch(updateAnnotation(annotationTask, value));
            }
          }}
        >
          {['ongoing', 'paused', 'archived'].map((item) => (
            <OptionStatus key={item} value={item} statusOption={item} />
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
